// @owners { team: patient-health }
// eslint-disable-next-line import/no-deprecated
import { unarchivePrescription } from '~shared/actions/prescriptions';
import getErrors from '~shared/features/ui/selectors/getErrors';
import getLoading from '~shared/features/ui/selectors/getLoading';
import { sendAnalyticsEvent } from '~shared/lib/analytics/src/actions';
import { connect } from '~shared/store';
import { type ReduxStateShared } from '~shared/types';
import PrescriptionInactiveArchived from './PrescriptionInactiveArchived';

function mapStateToProps(state: ReduxStateShared) {
  const errors = getErrors(state);
  const loading = getLoading(state);

  return {
    unarchivingPrescription: loading.unarchivePrescriptionLoading,
    unarchivePrescriptionError: errors.unarchivePrescriptionError,
  };
}

const mapDispatchToProps = {
  // eslint-disable-next-line import/no-deprecated
  unarchivePrescription,
  sendAnalyticsEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrescriptionInactiveArchived);
